export default __webpack_public_path__ + "static/media/logo.7e09371f.svg";